"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _setLoadComplete = _interopRequireDefault(require("./setLoadComplete"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var waitForLoad = function waitForLoad($component, useAutoTimeOut) {
  $component.removeClass('component-ready');
  $component.addClass('component-wait');

  if (useAutoTimeOut !== false) {
    setTimeout(function () {
      if (!$component.hasClass('component-ready')) {
        $component.addClass('component-failed');
        (0, _setLoadComplete["default"])($component);
      }
    }, 5000);
  }
};

var _default = waitForLoad;
exports["default"] = _default;